import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import _ from 'lodash';
import { ensure } from 'components/sharpr/ensure/ensure';

let menus = [];

/** @ignore */
export function MenuResolves(resolves) {
	resolves.__menus = ApiResourcify.endpoint('/config/menus', {
		withResponse: resp => (menus = processMenuData(resp.data)),
		cacheFor: 30 * 60 * 1000,
	});
}

function processMenuData(data) {
	if (!data) {
		return [];
	}
	var compile = item => {
		item.activeWhen = compileActiveWhen(item.activeWhen || item.href);
		if (item.children && item.children.length) {
			item.children.forEach(compile);
		}
	};
	_.forOwn(data, items => ensure.array(items).forEach(compile));
	return data;
}

function compileActiveWhen(str) {
	let escaped = str.replace(/\\/g, '\\/').replace(/\*/g, '.*');
	let hubbed = escaped.replace('hub\\/#', 'hub\\/?#').replace('hub#', 'hub\\/?#');
	let regex = RegExp('^https?://[^/]+' + hubbed);
	return regex;
}
/**
 * Get menus by name and get breadcrumbs
 */
export class MenuService {
	/**
	 * No dependencies
	 */
	construct() {
		'ngInject';
		// menus isn't set yet
	}

	/**
	 * Get menu data by name
	 * @param {String} menuName  The name returned by GET /config/menus
	 * @returns {Object[]}
	 */
	get(menuName) {
		return menus[menuName];
	}

	/**
	 * Get a list of parents for the given URL
	 * @param {String} menuName  The name returned by GET /config/menus
	 * @param {String} forUrl
	 * @returns {Object[]}
	 */
	breadcrumbs(menuName, forUrl = null) {
		// TODO: handle arbitrary number of levels
		let crumbs = [];
		this.get(menuName).some(item => {
			if (this.isActive(item, forUrl)) {
				crumbs.push(item);
				(item.children || []).some(child => {
					if (this.isActive(child, forUrl)) {
						crumbs.push(child);
						return true;
					}
				});
				return true;
			}
		});
		return crumbs;
	}

	/**
	 * Return true if the menu item matches the given URL
	 * @param {Object} item  Record returned by GET /config/menus
	 * @param {String} forUrl
	 * @returns {Boolean}
	 */
	isActive(item, forUrl = null) {
		return item.activeWhen && !!(forUrl || window.location.href).match(item.activeWhen);
	}

	//getActive(menuName) {
	//	return _.find(menus[menuName], {active: true});
	//}
	//
	//setActive(menuName, itemOrCriteria) {
	//	let items = this.get(menuName);
	//	let idx = items.indexOf(itemOrCriteria);
	//	if (idx >= 0) {
	//		// we want to set a particular item active
	//		items.forEach(item => item.active = false);
	//		items[idx].active = true;
	//	}
	//	else {
	//		// we want to set by criteria (e.g. {url:'/posts/intelligence'} or {text:'Curate'})
	//		let [active, inactive] = _.partition(items, itemOrCriteria);
	//		active.forEach(item => item.active = true);
	//		inactive.forEach(item => item.active = false);
	//	}
	//	return this;
	//}
}
